// Estrellas del Club — the prestige layer: five once-in-a-career milestones,
// each granting a permanent star (and a small permanent income boost via the
// modifier engine, STAR_INCOME_MULT). No prestige-reset: this game is one
// continuous career, so stars are trophies you keep.

export interface StarMilestone {
  id: string
  name: string
  description: string
  emoji: string
}

export const STAR_MILESTONES: StarMilestone[] = [
  {
    id: 'primera_title',
    name: 'Campeones de Primera',
    description: 'Gana el título de Primera División',
    emoji: '🏆',
  },
  {
    id: 'members_300',
    name: 'Marea de socios',
    description: 'Alcanza 300 socios',
    emoji: '👥',
  },
  {
    id: 'facilities_elite',
    name: 'Instalaciones de élite',
    description: 'Ten 4 instalaciones a nivel 5 o superior',
    emoji: '🏗️',
  },
  {
    id: 'half_million',
    name: 'Medio millón',
    description: 'Acumula 500.000€ de ingresos totales',
    emoji: '💰',
  },
  {
    id: 'major_champion',
    name: 'Reyes del Major',
    description: 'Conquista un Premier Padel Major con tu pareja',
    emoji: '👑',
  },
]

export function getStarMilestone(id: string): StarMilestone | undefined {
  return STAR_MILESTONES.find(m => m.id === id)
}

/** State-derived milestone checks (the Major star is event-driven instead) */
export interface PrestigeCheckState {
  leagueHistory: Array<{ division: number; position: number }>
  memberCounts: Record<string, number>
  buildings: Array<{ level: number }>
  totalIncome: number
}

export function checkStateMilestones(state: PrestigeCheckState): string[] {
  const earned: string[] = []

  if (state.leagueHistory.some(h => h.division === 1 && h.position === 1)) {
    earned.push('primera_title')
  }
  const members = Object.values(state.memberCounts).reduce((sum, c) => sum + c, 0)
  if (members >= 300) {
    earned.push('members_300')
  }
  if (state.buildings.filter(b => (b.level ?? 1) >= 5).length >= 4) {
    earned.push('facilities_elite')
  }
  if (state.totalIncome >= 500_000) {
    earned.push('half_million')
  }

  return earned
}
